import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import VueLazyload from 'vue-lazyload';
import { Locale } from 'vant';
import zhCN from 'vant/lib/locale/lang/zh-CN';
import zhTW from 'vant/lib/locale/lang/zh-TW';
import enUS from 'vant/lib/locale/lang/en-US';
import koKR from '@/assets/languages/ko-KR.js';

import 'video.js/dist/video-js.css'

localStorage.setItem('lang', 'zh_tw');
localStorage.removeItem('choose_page_cache');
const savelang = 'zh_tw';

// 设置 Vant 组件库语言
if (savelang === 'zh_cn') {
  Locale.use('zh-CN', zhCN);
} else if (savelang === 'zh_tw') {
  Locale.use('zh-TW', zhTW);
} else if (savelang === 'en_us') {
  Locale.use('en-US', enUS);
} else {
  Locale.use('ko-KR', koKR);
}

Vue.prototype.$http = http
Vue.prototype.$imgUrl = process.env.VUE_APP_IMG_URL
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(VueI18n);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/img/null.png',
  loading: '/img/null.png',
  attempt: 1,
  lazyComponent: true
});
const i18n = new VueI18n({
  globalInjection: true, 
  locale: savelang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
	'yn_yu': require('./assets/languages/yn_yu.json'),
    'zh_cn': require('./assets/languages/zh_cn.json'),
    'zh_tw': require('./assets/languages/zh_tw.json'),
    'en_us': require('./assets/languages/en_us.json'),
    'es_spa': require('./assets/languages/es_spa.json'),
    'ms_my': require('./assets/languages/ms_my.json'),
	'idn_yu': require('./assets/languages/idn_yu.json'),
  'ko_hy': require('./assets/languages/ko_hy.json'),
	
  }
});
new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
